import { render, staticRenderFns } from "./SlsPT.vue?vue&type=template&id=d2169210&scoped=true"
import script from "./SlsPT.vue?vue&type=script&lang=js"
export * from "./SlsPT.vue?vue&type=script&lang=js"
import style0 from "./_layout.css?vue&type=style&index=0&id=d2169210&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2169210",
  null
  
)

export default component.exports